import { actionTypes } from "../actions/default.action"

const initialState = {
  productVariations: {
    data: [],
  },
  productVariation: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        productVariations: {
          ...state.productVariations,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        productVariations: {
          ...state.productVariations,
          data: state.productVariations.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        productVariation: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
